import { useAuth } from "./useAuth";

/** Return the currently active payment processor. */
export function usePaymentProcessor() {
    const loginResult = useAuth((state) => state.loginResult);
    return loginResult?.settings.paymentProcessor;
}
